import React from "react";
import {
  DateInput,
  DocIcon,
  Field,
  SearchIcon,
  SectionHeader,
  SelectInput,
  Stepper,
  TextInput,
} from "./CreateBlockFields";

const BlockDefinition = ({
  blockName,
  setBlockName,
  blockCode,
  setBlockCode,
  blockStatus,
  setBlockStatus,
  startDate,
  endDate,
  nights,
  onStartDateChange,
  onEndDateChange,
  onNightsChange,
  market,
  setMarket,
  source,
  setSource,
  account,
  setAccount,
  reservationType,
  setReservationType,
  inventoryControl,
  setInventoryControl,
  blockOwner,
  setBlockOwner,
  decisionDate,
  setDecisionDate,
  openLookup,
}) => (
  <div className="col-md-12">
    <div className="cb-card">
      <SectionHeader
        icon={<DocIcon />}
        title="Block Definition"
        right={<span className="required-note">* Required Fields</span>}
      />
      <div className="cb-card-body">
        <div className="grid-row">
          <Field label="Block Name" required className="col-6">
            <TextInput
              placeholder="Enter corporate name"
              value={blockName}
              onChange={(event) => setBlockName(event.target.value)}
            />
          </Field>
          <Field label="Block Code" required className="col-3">
            <TextInput
              placeholder=" MMDDYYBON"
              value={blockCode}
              onChange={(event) => setBlockCode(event.target.value)}
            />
          </Field>
          <Field label="Block Status" required className="col-3">
            <SelectInput
              value={blockStatus}
              onChange={(event) => setBlockStatus(event.target.value)}
              options={["TEN", "DEF", "ACT", "CXL"]}
            />
          </Field>
        </div>
        <div className="grid-row">
          <Field label="Start Date" required className="col-2">
            <DateInput value={startDate} onChange={onStartDateChange} />
          </Field>
          <Field label="Nights" className="col-2 mx-auto">
            <Stepper
              value={nights}
              onDecrease={() => onNightsChange(-1)}
              onIncrease={() => onNightsChange(1)}
            />
          </Field>
          <Field label="End Date" required className="col-2">
            <DateInput value={endDate} onChange={onEndDateChange} />
          </Field>
          <Field label="Market" required className="col-3">
            <TextInput
              inputId="block-market"
              value={market}
              onChange={(event) => setMarket(event.target.value)}
              icon={<SearchIcon />}
              onIconClick={() => openLookup("market")}
            />
          </Field>
          <Field label="Source" required className="col-3">
            <TextInput
              inputId="block-source"
              value={source}
              onChange={(event) => setSource(event.target.value)}
              icon={<SearchIcon />}
              onIconClick={() => openLookup("source")}
            />
          </Field>
        </div>
        <div className="grid-row">
          <Field label="Account" className="col-3">
            <TextInput
              placeholder="Search accounts..."
              value={account}
              onChange={(event) => setAccount(event.target.value)}
              icon={<SearchIcon />}
              onIconClick={() => openLookup("account")}
            />
          </Field>
          <Field label="Reservation Type" required className="col-3">
            <TextInput
              value={reservationType}
              onChange={(event) => setReservationType(event.target.value)}
              icon={<SearchIcon />}
              onIconClick={() => openLookup("reservationType")}
            />
          </Field>
          <Field label="Inventory Control" className="col-2">
            <SelectInput
              value={inventoryControl}
              onChange={(event) => setInventoryControl(event.target.value)}
              options={["Elastic", "Sell-Limit", "Non-Elastic"]}
            />
          </Field>
          <Field label="Block Owner" required className="col-2">
            <TextInput
              value={blockOwner}
              disabled
            />
          </Field>
          <Field label="Decision Date" className="col-2">
            <DateInput value={decisionDate} onChange={setDecisionDate} />
          </Field>
        </div>
      </div>
    </div>
  </div>
);

export default BlockDefinition;
